import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home as HomeIcon } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/data/seo";

// Breadcrumbs with schema.org BreadcrumbList JSON-LD
export const Breadcrumbs = ({ trail }) => {
  // trail: [{ href, label }] — last item = current page
  const jsonld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map((t, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: t.label,
      item: `${SITE_URL}${t.href}`,
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
      </Helmet>
      <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="text-sm text-slate-500">
        <ol className="flex items-center flex-wrap gap-1">
          {trail.map((t, i) => {
            const last = i === trail.length - 1;
            return (
              <li key={t.href} className="flex items-center gap-1">
                {i === 0 && <HomeIcon className="h-3.5 w-3.5" />}
                {last ? (
                  <span className="text-[#0A192F] font-medium" aria-current="page">{t.label}</span>
                ) : (
                  <Link to={t.href} className="hover:text-[#0A192F]">{t.label}</Link>
                )}
                {!last && <ChevronRight className="h-3.5 w-3.5 mx-0.5" />}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
};
